const triggerEvent = (target, eventName) => {
  const event = new Event(eventName, { bubbles: true });
  target.dispatchEvent(event);
};

export default triggerEvent;
